const inboxes = [
    {
        "id":"1",
        "collNo":"R21081201",
        "type":"initial",
        "phase":"documentCheck",
        "activity":"documentCheck_S20",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠,屏東廠",
        "customerNo":"00001",
        "supplementItems":[
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅","subItem":"豆蓉粉(新版)", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)",
                "reviewHistories":[
                    {"reviewDate":"2021-07-12T08:20:10.000Z","reviewComments":"檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明","supplementDate":"2021-07-16T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"},
                    {"reviewDate":"2021-07-18T08:20:10.000Z","reviewComments":"所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽","supplementDate":"2021-07-20T08:20:10.000Z", "supplemented":true,"supplementedDesc":"XXXXX"}
                ]},
            {"nodeId":"3_assessmentProduct", "category":"評鑑產品", "item":"桂圓四物飲","subItem":"美國加州杏仁果","comments":"原料H-紅茶葉119(金洋):(使用於成品女兒紅茶、女兒紅茶包)\n" +
                    "(1)所提供之輸入許可通知品名為烏龍茶無法與原料名稱紅茶葉勾稽。且明細表及外標示亦無法和輸入許可證的報驗義務人原津股份有限公司勾稽，請確認並重新提供。\n" +
                    "(2)檢驗報告也無法勾稽且已過期一年，請說明。\n" +
                    "(3)外標示照片無供應商金洋可勾稽，請重新提供標示照片(或提供進貨單據)"},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知"}
        ],
        "stayDays":3
    },
    {
        "id":"2",
        "collNo":"R21080102",
        "appNo":"A21080202",
        "type":"initial",
        "phase":"documentReview",
        "activity":"documentReview_S30",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "customerNo":"00001",
        "supplementItems":[
            {"nodeId":"1_factoryFloorPlan", "category":"屏東廠", "item":"廠區平面圖", "comments":"依據所提供之工廠平面圖，有B1及1F，請確認是否為評鑑場所範圍內?若是請於計畫書P.6新增B1及1F地址"},
            {"nodeId":"1_assessmentProduct", "category":"評鑑產品","item":"杏仁玄米餅", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)"},
            {"nodeId":"4_assessmentProduct", "category":"評鑑產品","item":"Natural Benefits 食安生技-椰子汁", "comments":"1.跟零食一樣爽脆、熱量只有1/20！吃西洋芹紓壓解熱還能補足多種營養 2.請附輸入食品許可通知"}
        ],
        "stayDays":1
    },
    {
        "id": "2.2",
        "collNo":"R21081501",
        "appNo":"A21080501",
        "type":"renewal",
        "phase":"documentReview",
        "activity":"documentReview_S30",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "customerNo":"00001",
        "stayDays":4,
        "supplementItems": [
            {
                "item": "productAttachmentOverdueList",
                "subItem": "杏仁玄米餅",
                "attachmentType": "productInspectionReport",
                "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 ",
                "reviewHistories": [
                    {
                        "reviewDate": "2022-02-07T00:00:00.000Z",
                        "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                        "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                    },
                    {
                        "reviewDate": "2022-02-08T00:00:00.000Z",
                        "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                        "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                    },
                ],
            },
            {
                "item": "rawMaterialAttachmentOverdueList",
                "subItem": "豆蓉粉",
                "attachmentType": "inspectionReport",
                "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 ",
                "reviewHistories": [
                    {
                        "reviewDate": "2022-02-07T00:00:00.000Z",
                        "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                        "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                    },
                    {
                        "reviewDate": "2022-02-08T00:00:00.000Z",
                        "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                        "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                    },
                ],
            }
        ],
        "applicationData": {
            "customerName": "源天然股份有限公司",
            "appNo": "A21100101",
            "assessmentPlace": "台東廠",
            "createdOn": "2021-10-01T08:00:00.000Z",
            "confirmStatement": true,
            "productionLineRemoves": [
                {
                    "productionLine": "果汁線",
                    "removes":[
                        {
                            "name": "Natural Benefits 食安生技-椰子汁",
                            "tseyueLevel": "doubleClean",
                            "leezenLevel": "organic",
                            "productionLine": "果汁線",
                            "processStatus": "frontEnd",
                            "packaging": "tetraPak",
                            "spec": "250ml/包",
                            "channel": ["leezen"],
                            "backEndName": "食安生技-椰子汁",
                            "status": "approve",
                        },
                        {
                            "name": "Natural Benefits 食安生技-椰子汁",
                            "tseyueLevel": "doubleClean",
                            "leezenLevel": "organic",
                            "productionLine": "果汁線",
                            "processStatus": "frontEnd",
                            "packaging": "tetraPak",
                            "spec": "360ml/包",
                            "channel": ["leezen"],
                            "backEndName": "食安生技-椰子汁",
                            "status": "improvement",
                        },
                        {
                            "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                            "tseyueLevel": "doubleClean",
                            "leezenLevel": "organic",
                            "productionLine": "果汁線",
                            "processStatus": "frontEnd",
                            "packaging": "tetraPak",
                            "spec": "250ml/包",
                            "channel": ["leezen"],
                            "backEndName": "純在葡萄柚蘋果綠茶",
                            "status": "suspend",
                        },
                        {
                            "name": "atural Benefits 純在葡萄柚蘋果綠茶",
                            "tseyueLevel": "doubleClean",
                            "leezenLevel": "organic",
                            "productionLine": "果汁線",
                            "processStatus": "frontEnd",
                            "packaging": "tetraPak",
                            "spec": "360ml/包",
                            "channel": ["leezen"],
                            "backEndName": "純在葡萄柚蘋果綠茶",
                            "status": "approve",
                        },
                    ]
                },
                {
                    "productionLine": "飲料線",
                    "removes":[
                        {
                            "name": "桂圓四物飲",
                            "tseyueLevel": "",
                            "leezenLevel": "organic",
                            "productionLine": "飲料線",
                            "processStatus": "backEnd",
                            "packaging": "glassBottle",
                            "spec": "360ml/瓶",
                            "channel": ["leezen", "family"],
                            "status": "approve",
                        },
                        {
                            "name": "桂圓四物飲",
                            "tseyueLevel": "",
                            "leezenLevel": "organic",
                            "productionLine": "飲料線",
                            "processStatus": "backEnd",
                            "packaging": "glassBottle",
                            "spec": "1000ml/瓶",
                            "channel": ["leezen", "family"],
                            "status": "approve",
                        },
                    ]
                },
                {
                    "productionLine": "餅乾線",
                    "removes":[
                        {
                            "name": "杏仁玄米餅",
                            "tseyueLevel": "doubleClean",
                            "leezenLevel": "organic",
                            "productionLine": "餅乾線",
                            "processStatus": "backEnd",
                            "packaging": "paperBag",
                            "spec": "200/盒",
                            "channel": ["leezen"],
                            "status": "approve",
                        },
                    ]
                },
            ],
            "productAttachmentOverdueList": [
                {
                    "id": "1",
                    "reviewResult": "disagree",
                    "product": "杏仁玄米餅",
                    "attachmentType": "productInspectionReport",
                    "filenameOld": "檔案11.pdf",
                    "validDateOld": "2021-10-01T08:00:00.000Z",
                    "dateType": "報告日期",
                    "newDate": "2022-02-08T08:00:00.000Z",
                    "description": "說明 說明 說明 說明 說明 說明 說明 說明 ",
                    "reviewHistories": [
                        {
                            "reviewDate": "2022-02-07T00:00:00.000Z",
                            "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                            "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                        },
                        {
                            "reviewDate": "2022-02-08T00:00:00.000Z",
                            "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                            "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                        },
                    ],
                },
                {
                    "id": "2",
                    "reviewResult": "agree",
                    "product": "杏仁玄米餅",
                    "attachmentType": "productInspectionReport",
                    "filenameOld": "檔案12.pdf",
                    "validDateOld": "2021-10-01T08:00:00.000Z",
                    "dateType": "報告日期",
                    "newDate": "2022-02-08T08:00:00.000Z",
                    "description": "說明 說明 說明 說明 說明 說明 說明 說明 ",
                    "reviewHistories": [
                        {
                            "reviewDate": "2022-02-07T00:00:00.000Z",
                            "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                            "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                        },
                        {
                            "reviewDate": "2022-02-08T00:00:00.000Z",
                            "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                            "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                        },
                    ],
                },
                {
                    "id": "3",
                    "reviewResult": "agree",
                    "product": "杏仁玄米餅",
                    "attachmentType": "importOrganicConsentDoc",
                    "filenameOld": "檔案21.pdf",
                    "validDateOld": "2021-11-20T08:00:00.000Z",
                    "dateType": "文件日期",
                    "newDate": "2022-02-08T08:00:00.000Z",
                    "description": "說明 說明 說明 說明 說明 說明 說明 說明 ",
                },
                {
                    "id": "4",
                    "reviewResult": "agree",
                    "product": "杏仁玄米餅",
                    "attachmentType": "enterFoodPermissionNotice",
                    "filenameOld": "檔案31.pdf",
                    "validDateOld": "2021-09-30T08:00:00.000Z",
                    "dateType": "報告日期",
                    "newDate": "2022-02-08T08:00:00.000Z",
                    "description": "說明 說明 說明 說明 說明 說明 說明 說明 ",
                },
                {
                    "id": "5",
                    "reviewResult": "agree",
                    "product": "杏仁玄米餅",
                    "attachmentType": "alcoholContentTestReport",
                    "filenameOld": "檔案41.pdf",
                    "validDateOld": "2021-12-09T08:00:00.000Z",
                    "dateType": "報告日期",
                    "newDate": "2022-02-08T08:00:00.000Z",
                    "description": "說明 說明 說明 說明 說明 說明 說明 說明 ",
                },
                {
                    "id": "6",
                    "reviewResult": "agree",
                    "product": "桂圓四物飲",
                    "attachmentType": "importOrganicConsentDoc",
                    "filenameOld": "檔案51.pdf",
                    "validDateOld": "2021-12-05T08:00:00.000Z",
                    "dateType": "文件日期",
                    "newDate": "2022-02-08T08:00:00.000Z",
                    "description": "說明 說明 說明 說明 說明 說明 說明 說明 ",
                },
            ],
            "rawMaterialAttachmentOverdueList": [
                {
                    "id": "1",
                    "reviewResult": "disagree",
                    "rawMaterial": "豆蓉粉",
                    "product": "杏仁玄米餅",
                    "attachmentType": "inspectionReport",
                    "filenameOld": "檔案11.pdf",
                    "validDateOld": "2021-10-01T08:00:00.000Z",
                    "dateType": "報告日期",
                    "type":"material",
                    "storageCondition":"roomTemperature",
                    "composition":"",
                    "domesticVendor":"穎昌食品有限公司(新和美)",
                    "importer":"",
                    "manufacturer":"穎昌食品有限公司(新和美)",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "addRatio":9,
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":1,
                    "newDate": "2022-02-08T08:00:00.000Z",
                    "relatedDocuments":[
                        {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                        {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                    ],
                    "reviewHistories": [
                        {
                            "reviewDate": "2022-02-07T00:00:00.000Z",
                            "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                            "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                        },
                        {
                            "reviewDate": "2022-02-08T00:00:00.000Z",
                            "reviewDesc": "審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 審查說明 ",
                            "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
                        },
                    ],
                },
                {
                    "id": "2",
                    "reviewResult": "agree",
                    "disable": true,
                    "rawMaterial": "美國加州杏仁果",
                    "product": "杏仁玄米餅、杏仁巧克力酥",
                    "attachmentType": "foodAdditiveLicense",
                    "filenameOld": "檔案12.pdf",
                    "validDateOld": "2021-10-01T08:00:00.000Z",
                    "dateType": "有效日期",
                    "type":"material",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"信成股份有限公司",
                    "importer":"信成股份有限公司",
                    "manufacturer":"TERRA NOVA TRADING INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":2,
                    "newDate": "2022-02-08T08:00:00.000Z",
                },
                {
                    "id": "3",
                    "reviewResult": "agree",
                    "rawMaterial": "有機生糙米粉(台灣)",
                    "product": "杏仁巧克力酥",
                    "attachmentType": "enterFoodPermissionNotice",
                    "filenameOld": "檔案21.pdf",
                    "validDateOld": "2021-11-20T08:00:00.000Z",
                    "dateType": "進口日期",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"青田農產有限公司",
                    "importer":"",
                    "manufacturer":"青田農產有限公司",
                    "originPlace":"台灣",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":8,
                    "newDate": "2022-02-08T08:00:00.000Z",
                },
                {
                    "id": "4",
                    "reviewResult": "agree",
                    "rawMaterial": "甜扁桃仁粒",
                    "product": "杏仁玄米餅",
                    "attachmentType": "importOrganicConsentDoc",
                    "filenameOld": "檔案31.pdf",
                    "validDateOld": "2021-09-30T08:00:00.000Z",
                    "dateType": "有效日期",
                    "storageCondition":"refrigeration",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"TWIN COMMODITIES,INC.",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":6,
                    "newDate": "2022-02-08T08:00:00.000Z",
                },
                {
                    "id": "5",
                    "reviewResult": "agree",
                    "rawMaterial": "杏仁粉(細)",
                    "product": "杏仁玄米餅",
                    "attachmentType": "organicCertificate",
                    "filenameOld": "檔案41.pdf",
                    "validDateOld": "2021-12-09T08:00:00.000Z",
                    "dateType": "有效日期",
                    "storageCondition":"roomTemperature",
                    "domesticVendor":"成久旺股份有限公司",
                    "importer":"成久旺股份有限公司",
                    "manufacturer":"Treehouse California Almonds LLC",
                    "originPlace":"美國",
                    "additiveLicenseNumber":"",
                    "processingAid":"N",
                    "accessory":"N",
                    "ingredientOrder":11,
                    "newDate": "2022-02-08T08:00:00.000Z",
                },
            ]
        },
    },
    {
        "id": "2.5",
        "collNo":"R21081501",
        "appNo":"A21081501",
        "type":"change",
        "phase":"documentReview",
        "activity":"documentReview_S30",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "customerNo":"00001",
        "stayDays":5,
        "urgent": true,
        "urgentDescription": "急件需求說明......",
        "urgentReply": "急件說明回覆......",
        "supplementItems":[
            {"nodeId":"1_factoryFloorPlan", "changeType": "assessmentPlaceDataChange", "item":"台東廠", "subItem":"廠區平面圖", "comments":"依據所提供之工廠平面圖，有B1及1F，請確認是否為評鑑場所範圍內?若是請於計畫書P.6新增B1及1F地址"},
            {"nodeId":"1_assessmentProduct", "changeType":"assessmentProductChange","item":"杏仁玄米餅", "comments":"原料H-牛蒡片005(牛蒡片)(使用於成品黑豆牛蒡茶、牛蒡養生茶、人參黃耆茶、黑豆牛蒡茶包)\n" +
                    "(1)檢驗報告申請廠商為高達食品行，無法和長昇勾稽，請說明。\n" +
                    "(2)所提供之外標示照片無供應商及製造商可與明細表長昇蔘藥行有限公司勾稽，請重新提供標示照片(或提供進貨單據)"}
        ],
        "changes": [
            {
                "changeType":"customerBasicInformationChange",
                "description": "異動說明................",
                "customerBasicInfo":{
                    "individual":false,
                    "customerNo":"00020",
                    "customerName":"源天然股份有限公司",
                    "taxIdNo":"83793371",
                    "personInCharge":"羅永昌",
                    "registeredAddress":{
                        "country":"TW",
                        "zip":"958",
                        "city":"taitung",
                        "district":"池上鄉",
                        "street":"振興村11鄰145號"
                    },
                    "tel":"089-360960",
                    "standards":["tseyue","leezen"],
                    "subContractorFilledCompletely":"Y",
                    "qualityManagementDoc1":true,
                    "qualityManagementDoc2":true,
                    "qualityManagementDoc3":true,
                    "qualityManagementDoc4":"prepared",
                    "paymentAccount":{
                        "bankCode":"822",
                        "bankName":"中國信託",
                        "branch":"台東分行",
                        "accountName":"源天然股份有限公司",
                        "accountNo":"0091234098"
                    },
                    "refundAccount":{
                        "bankCode":"822",
                        "bankName":"中國信託",
                        "branch":"台東分行",
                        "accountName":"源天然股份有限公司",
                        "accountNo":"0091234110"
                    },
                    "commodityLabelStatements":[
                        {
                            "filename":"A供應商商品標示.pdf",
                            "description":"A供應商商品標示聲明"
                        },
                        {
                            "filename":"B供應商商品標示.pdf",
                            "description":"B供應商商品標示聲明"
                        },
                        {
                            "filename":"C供應商商品標示.pdf",
                            "description":"C供應商商品標示聲明"
                        },
                        {
                            "filename":"D供應商商品標示.pdf",
                            "description":"D供應商商品標示聲明"
                        },
                        {
                            "filename":"E供應商商品標示.pdf",
                            "description":"E供應商商品標示聲明"
                        },
                        {
                            "filename":"F供應商商品標示.pdf",
                            "description":"F供應商商品標示聲明"
                        }
                    ]
                },
            },
            {
                "changeType":"assessmentPlaceDataChange",
                "description": "異動說明................",
                "assessmentPlaces":[
                    {
                        "id":"1",
                        "name":"台東廠",
                        "personInCharge":"王小花",
                        "masterAddress":"958台東縣池上鄉振興二號產業道路",
                        "relationshipWithApplicant":"company",
                        "productLabelingTel":"02-7723-8001",
                        "factoryRegistration":"yes",
                        "contactPerson":"王小花",
                        "jobTitle":"行政專員",
                        "email":"anniewang@gmail.com",
                        "phoneNumber":"02-7723-8001",
                        "extension":"201 ~ 203",
                        "mobilePhone":"0911290098",
                        "fax":"02-7723-8002",
                        "passedManagementSystems":["iso2200","tqf","others"],
                        "otherManagementSystem":"波蘭台北辦事處也在推特表示，「這是對需要幫助的朋友，我們所給予的堅定有力的支持」，也希望大家能健康平安，同時分享這批疫苗的照片，可以看見上面貼有「TAIWAN」字樣。",
                        "managementSystemCertificateEffectiveDate":"2021-05-12T08:20:10.000Z",
                        "passedManagementSystemCertificates":[
                            {"certificate":"ISO2200 證書", "effectiveDate":"2023-05-12T08:20:10.000Z"},
                            {"certificate":"TQF 證書", "effectiveDate":"2022-12-31T08:20:10.000Z"}
                        ],
                        "addresses":[
                            {
                                "country":"TW",
                                "zip":"11501",
                                "city":"taipei",
                                "district":"南港區",
                                "street":"三重路19-11號",
                                "mainAddress":true,
                                "fullAddress":"11501 台北市南港區三重路19-11號"
                            }
                        ],
                        "referenceDocument":{
                            "documentPoint1":"ready",
                            "documentPoint2":"ready",
                            "documentPoint3":"unused",
                            "documentPoint4":"ready",
                        },
                        "factoryFloorPlans":[
                            {
                                "id":"1",
                                "address":"11501 台北市南港區三重路19-11號",
                                "filename":"原料處理區及加工調理區.pdf",
                                "description":"原料處理區及加工調理區"
                            },
                            {
                                "id":"2",
                                "address":"11501 台北市南港區三重路19-11號",
                                "filename":"食品添加物室.jpeg",
                                "description":"食品添加物室"
                            }
                        ],
                        "productionLines":[
                            {
                                "id":"1",
                                "name":"果汁線",
                                "waterUse":"coolDown",
                                "processEquipments":[
                                    {
                                        "id":"1",
                                        "equipment":"清洗設備",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"2",
                                        "equipment":"榨汁機",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"3",
                                        "equipment":"果汁緩衝桶",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"4",
                                        "equipment":"半自動充填機",
                                        "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                        "frequency":"每生產前"
                                    }
                                ],
                                "useLubricant":'Y',
                                "lubricantDescriptions":[
                                    {
                                        "id":"1",
                                        "name":"烤盤專用油",
                                        "element":"芥花油,大豆卵磷脂",
                                        "usage":"用於烤盤"
                                    },
                                    {
                                        "id":"2",
                                        "name":"YY潤滑劑",
                                        "element":"硫化鋅、石蠟、礦物油",
                                        "usage":"輸送帶鏈條"
                                    }
                                ]
                            },
                            {
                                "id":"2",
                                "name":"運動飲料線",
                                "waterUse":"others",
                                "waterUseDesc":"test111",
                                "processEquipments":[
                                    {
                                        "id":"1",
                                        "equipment":"清洗設備111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"2",
                                        "equipment":"榨汁機111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"3",
                                        "equipment":"果汁緩衝桶111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"4",
                                        "equipment":"半自動充填機111",
                                        "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                        "frequency":"每生產前"
                                    }
                                ],
                                "useLubricant":'N'
                            }
                        ]
                    }
                ],
            },
            {
                "changeType":"assessmentProductChange",
                "description": "異動說明................",
                "assessmentProducts": [
                    {
                        "id":"1",
                        "name":"杏仁玄米餅",
                        "combination":false,
                        "tseyueStandard":true,
                        "tseyueLevel":"doubleClean",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["aluminumCan","glassBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"]},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"1公斤/包", "channels":["leezen","family"]},
                                    {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                    },
                    {
                        "id":"2",
                        "name":"Pasta義大利麵",
                        "combination":true,
                        "tseyueStandard":true,
                        "leezenStandard":true,
                        "tseyueLevel":"doubleClean",
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "processStatus":"backEnd",
                        "packagingMethods":["plasticBag"],
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"]},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"1公斤/包", "channels":["leezen","family"]},
                                    {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                    },
                    {
                        "id":"3",
                        "name":"桂圓四物飲",
                        "leezenStandard":true,
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["plasticBottle","plasticBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"]},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"1公斤/包", "channels":["leezen","family"]},
                                    {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                    },
                ],
                "assessmentPlaces":[
                    {
                        "id":"1",
                        "name":"台東廠",
                        "personInCharge":"王小花",
                        "masterAddress":"958台東縣池上鄉振興二號產業道路",
                        "relationshipWithApplicant":"company",
                        "productLabelingTel":"02-7723-8001",
                        "factoryRegistration":"yes",
                        "contactPerson":"王小花",
                        "jobTitle":"行政專員",
                        "email":"anniewang@gmail.com",
                        "phoneNumber":"02-7723-8001",
                        "extension":"201 ~ 203",
                        "mobilePhone":"0911290098",
                        "fax":"02-7723-8002",
                        "passedManagementSystems":["iso2200","tqf","others"],
                        "otherManagementSystem":"波蘭台北辦事處也在推特表示，「這是對需要幫助的朋友，我們所給予的堅定有力的支持」，也希望大家能健康平安，同時分享這批疫苗的照片，可以看見上面貼有「TAIWAN」字樣。",
                        "managementSystemCertificateEffectiveDate":"2021-05-12T08:20:10.000Z",
                        "passedManagementSystemCertificates":[
                            {"certificate":"ISO2200 證書", "effectiveDate":"2023-05-12T08:20:10.000Z"},
                            {"certificate":"TQF 證書", "effectiveDate":"2022-12-31T08:20:10.000Z"}
                        ],
                        "addresses":[
                            {
                                "country":"TW",
                                "zip":"11501",
                                "city":"taipei",
                                "district":"南港區",
                                "street":"三重路19-11號",
                                "mainAddress":true,
                                "fullAddress":"11501 台北市南港區三重路19-11號"
                            }
                        ],
                        "referenceDocument":{
                            "documentPoint1":"ready",
                            "documentPoint2":"ready",
                            "documentPoint3":"unused",
                            "documentPoint4":"ready",
                        },
                        "factoryFloorPlans":[
                            {
                                "id":"1",
                                "filename":"原料處理區及加工調理區.pdf",
                                "description":"原料處理區及加工調理區"
                            },
                            {
                                "id":"2",
                                "filename":"食品添加物室.jpeg",
                                "description":"食品添加物室"
                            }
                        ],
                        "productionLines":[
                            {
                                "id":"1",
                                "name":"果汁線",
                                "waterUse":"coolDown",
                                "processEquipments":[
                                    {
                                        "id":"1",
                                        "equipment":"清洗設備",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"2",
                                        "equipment":"榨汁機",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"3",
                                        "equipment":"果汁緩衝桶",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"4",
                                        "equipment":"半自動充填機",
                                        "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                        "frequency":"每生產前"
                                    }
                                ],
                                "useLubricant":'Y',
                                "lubricantDescriptions":[
                                    {
                                        "id":"1",
                                        "name":"烤盤專用油",
                                        "element":"芥花油,大豆卵磷脂",
                                        "usage":"用於烤盤"
                                    },
                                    {
                                        "id":"2",
                                        "name":"YY潤滑劑",
                                        "element":"硫化鋅、石蠟、礦物油",
                                        "usage":"輸送帶鏈條"
                                    }
                                ]
                            },
                            {
                                "id":"2",
                                "name":"運動飲料線",
                                "waterUse":"others",
                                "waterUseDesc":"test111",
                                "processEquipments":[
                                    {
                                        "id":"1",
                                        "equipment":"清洗設備111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"2",
                                        "equipment":"榨汁機111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"3",
                                        "equipment":"果汁緩衝桶111",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"4",
                                        "equipment":"半自動充填機111",
                                        "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                        "frequency":"每生產前"
                                    }
                                ],
                                "useLubricant":'N'
                            }
                        ]
                    },
                    {
                        "id":"2",
                        "name":"屏東廠",
                        "personInCharge":"王小玉",
                        "masterAddress":"945屏東縣牡丹鄉石門村26號",
                        "relationshipWithApplicant":"entrust",
                        "productLabelingTel":"02-7723-8001",
                        "factoryRegistration":"no",
                        "contactPerson":"王小花",
                        "jobTitle":"行政專員",
                        "email":"anniewang@gmail.com",
                        "phoneNumber":"02-7723-8001",
                        "extension":"201 ~ 203",
                        "mobilePhone":"0911290098",
                        "fax":"02-7723-8002",
                        "passedManagementSystems":["haccp","tqf"],
                        "addresses":[
                            {
                                "country":"TW",
                                "zip":"11501",
                                "city":"taipei",
                                "district":"南港區",
                                "street":"三重路19-11號",
                                "mainAddress":true,
                                "fullAddress":"11501 台北市南港區三重路19-11號"
                            }
                        ],
                        "referenceDocument":{
                            "documentPoint1":"ready",
                            "documentPoint2":"ready",
                            "documentPoint3":"unused",
                            "documentPoint4":"ready",
                        },
                        "factoryFloorPlans":[
                            {
                                "id":"1",
                                "filename":"原料處理區.pdf",
                                "description":"原料處理區"
                            },
                            {
                                "id":"1",
                                "filename":"加工調理區.pdf",
                                "description":"加工調理區"
                            },
                            {
                                "id":"2",
                                "filename":"食品添加物作業場所.jpeg",
                                "description":"整個「倫敦橋行動」於D+10日落幕。英國將於西敏寺舉行國葬，全國也於正午時分默哀兩分鐘，倫敦與溫莎亦會舉行紀念活動"
                            }
                        ],
                        "productionLines":[
                            {
                                "id":"1",
                                "name":"吐司生產線",
                                "waterUse":"coolDown",
                                "processEquipments":[
                                    {
                                        "id":"1",
                                        "equipment":"清洗設備",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"2",
                                        "equipment":"榨汁機",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"3",
                                        "equipment":"果汁緩衝桶",
                                        "cleaningMethod":"CIP",
                                        "frequency":"每次(品項)"
                                    },
                                    {
                                        "id":"4",
                                        "equipment":"半自動充填機",
                                        "cleaningMethod":"生產前後-空氣槍噴清潔,酒精擦拭",
                                        "frequency":"每生產前"
                                    }
                                ],
                                "useLubricant":'N'
                            }
                        ]
                    }
                ],
            },
            {
                "changeType":"rawMaterialChange",
                "assessmentProducts": [
                    {
                        "id":"1",
                        "name":"杏仁玄米餅",
                        "combination":false,
                        "tseyueStandard":true,
                        "tseyueLevel":"doubleClean",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["aluminumCan","glassBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "status": "approve",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"]},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"1公斤/包", "channels":["leezen","family"]},
                                    {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                        "rawMaterials":[
                            {
                                "id":"1",
                                "type":"material",
                                "name":"豆蓉粉(新版)",
                                "storageCondition":"roomTemperature",
                                "composition":"",
                                "domesticVendor":"穎昌食品有限公司(新和美)",
                                "importer":"",
                                "manufacturer":"穎昌食品有限公司(新和美)",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "addRatio":9,
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":1,
                                "relatedDocuments":[
                                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                                ]
                            },
                            {
                                "id":"2",
                                "type":"material",
                                "name":"美國加州杏仁果",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信成股份有限公司",
                                "importer":"信成股份有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":2
                            },
                            {
                                "id":"3",
                                "type":"material",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"爾邦得有限公司",
                                "importer":"爾邦得有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":3
                            },
                            {
                                "id":"4",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"RPAC,LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":4
                            },
                            {
                                "id":"5",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"VANN FAMLLY ORCHARDS",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":5
                            },
                            {
                                "id":"6",
                                "name":"甜扁桃仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"TWIN COMMODITIES,INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":6
                            },
                            {
                                "id":"7",
                                "name":"帶皮杏仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"昇祥股份有限公司",
                                "importer":"昇祥股份有限公司",
                                "manufacturer":"美國加州皮爾農場公司",
                                "originPlace":"美國加州",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":7
                            },
                            {
                                "id":"8",
                                "name":"有機生糙米粉(台灣)",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"青田農產有限公司",
                                "importer":"",
                                "manufacturer":"青田農產有限公司",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":8
                            },
                            {
                                "id":"9",
                                "name":"精製椰子油",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"禾發實業有限公司",
                                "importer":"禾發實業有限公司",
                                "manufacturer":"OLEO-FATS, INCORPORATED",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":9
                            },
                            {
                                "id":"10",
                                "name":"杏仁細粉",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"迦得貿易實業有限公司",
                                "importer":"迦得貿易實業有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":10
                            },
                            {
                                "id":"11",
                                "name":"杏仁粉(細)",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":11
                            },
                            {
                                "id":"12",
                                "name":"混合濃縮生育醇",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信意企業股份有限公司",
                                "importer":"信意企業股份有限公司",
                                "manufacturer":"CARGILL INCORPORATED",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                "processingAid":"N",
                                "accessory":"N"
                            }
                        ]
                    },
                    {
                        "id":"2",
                        "name":"Pasta義大利麵",
                        "combination":false,
                        "tseyueStandard":true,
                        "leezenStandard":true,
                        "tseyueLevel":"doubleClean",
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "processStatus":"backEnd",
                        "packagingMethods":["plasticBag"],
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "status": "expire",
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"]},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"1公斤/包", "channels":["leezen","family"]},
                                    {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                        "rawMaterials":[
                            {
                                "id":"1",
                                "type":"material",
                                "name":"豆蓉粉(新版)",
                                "storageCondition":"roomTemperature",
                                "composition":"",
                                "domesticVendor":"穎昌食品有限公司(新和美)",
                                "importer":"",
                                "manufacturer":"穎昌食品有限公司(新和美)",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "addRatio":9,
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":1,
                                "relatedDocuments":[
                                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                                ]
                            },
                            {
                                "id":"2",
                                "type":"material",
                                "name":"美國加州杏仁果",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信成股份有限公司",
                                "importer":"信成股份有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":2
                            },
                            {
                                "id":"3",
                                "type":"material",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"爾邦得有限公司",
                                "importer":"爾邦得有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":3
                            },
                            {
                                "id":"4",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"RPAC,LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":4
                            },
                            {
                                "id":"5",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"VANN FAMLLY ORCHARDS",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":5
                            },
                            {
                                "id":"6",
                                "name":"甜扁桃仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"TWIN COMMODITIES,INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":6
                            },
                            {
                                "id":"7",
                                "name":"帶皮杏仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"昇祥股份有限公司",
                                "importer":"昇祥股份有限公司",
                                "manufacturer":"美國加州皮爾農場公司",
                                "originPlace":"美國加州",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":7
                            },
                            {
                                "id":"8",
                                "name":"有機生糙米粉(台灣)",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"青田農產有限公司",
                                "importer":"",
                                "manufacturer":"青田農產有限公司",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":8
                            },
                            {
                                "id":"9",
                                "name":"精製椰子油",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"禾發實業有限公司",
                                "importer":"禾發實業有限公司",
                                "manufacturer":"OLEO-FATS, INCORPORATED",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":9
                            },
                            {
                                "id":"10",
                                "name":"杏仁細粉",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"迦得貿易實業有限公司",
                                "importer":"迦得貿易實業有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":10
                            },
                            {
                                "id":"11",
                                "name":"杏仁粉(細)",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":11
                            },
                            {
                                "id":"12",
                                "name":"混合濃縮生育醇",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信意企業股份有限公司",
                                "importer":"信意企業股份有限公司",
                                "manufacturer":"CARGILL INCORPORATED",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                "processingAid":"N",
                                "accessory":"N"
                            }
                        ]
                    },
                    {
                        "id":"3",
                        "name":"桂圓四物飲",
                        "leezenStandard":true,
                        "leezenLevel":"organic",
                        "manufacturingProcess":"backEnd",
                        "packagingMethods":["plasticBottle","plasticBottle"],
                        "processStatus":"frontEnd",
                        "backEndProducts":"Natural Benefits 純在葡萄柚蘋果綠茶",
                        "storageCondition":"freezing",
                        "shelfLife":1,
                        "shelfLifeUnit":"year",
                        "onMarketForSale":"yes",
                        "saleArea":"onlyTaiwan",
                        "lowAcidFood":"N",
                        "status": "approve",
                        "applyStandards":[
                            {
                                "id":"11",
                                "standard":"tseyueStandard",
                                "level":"doubleClean"
                            }
                        ],
                        "placesAndLines":[
                            {
                                "place":"1",
                                "lines":["1","2"]
                            }
                        ],
                        "innerPackages":[
                            {
                                "packaging":"glassBottle",
                                "specs":[
                                    {"spec":"360ml/瓶", "channels":["leezen","family"]},
                                    {"spec":"1000ml/瓶", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "bottleInnerMaterial":"PE發泡塑膠",
                                "vacuumOrDesiccant":"Y",
                                "recycledAndReused":"N",
                                "vacuumOrDesiccantDesc":"隨後登基公告將於聖詹姆斯宮與倫敦的皇家交易所宣讀。下午15時30分，首相與內閣成員將晉見新王。"
                            },
                            {
                                "packaging":"plasticBag",
                                "specs":[
                                    {"spec":"1公斤/包", "channels":["leezen","family"]},
                                    {"spec":"2公斤/包", "channels":["others"], "otherDesc":"XXXX"}
                                ],
                                "material":"聚乙烯（PE)",
                                "vacuumOrDesiccant":"N",
                                "recycledAndReused":"N"
                            }
                        ],
                        "relatedAttachments":[
                            {"type":"productionFlowChart"},
                            {"type":"productionSpecSheet"},
                            {"type":"productionSpecSheet"},
                            {"type":"productPesticideResidue","date":"2021-06-01T08:20:10.000Z", "description":"報告日期"},
                            {"type":"organicCertificate","date":"2023-07-01T08:20:10.000Z", "description":"有效日期"},
                            {"type":"importOrganicConsentDoc","date":"2020-03-01T08:20:10.000Z", "description":"文件日期"},
                            {"type":"enterFoodPermissionNotice","date":"2020-01-01T08:20:10.000Z", "description":"進口日期"},
                            {"type":"alcoholTestReport"}
                        ],
                        "rawMaterials":[
                            {
                                "id":"1",
                                "name":"豆蓉粉(新版)",
                                "storageCondition":"roomTemperature",
                                "composition":"",
                                "domesticVendor":"穎昌食品有限公司(新和美)",
                                "importer":"",
                                "manufacturer":"穎昌食品有限公司(新和美)",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "addRatio":9,
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":1,
                                "relatedDocuments":[
                                    {"type":"foodAdditiveLicense","filename":"食品添加物許可證123.pdf", "dateType":"effective", "date":"2021-06-01T08:20:10.000Z"},
                                    {"type":"foodPermission","filename":"食品輸入許可通知證明2021.pdf", "dateType":"importDate", "date":"2021-01-01T08:20:10.000Z"},
                                ]
                            },
                            {
                                "id":"2",
                                "name":"美國加州杏仁果",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信成股份有限公司",
                                "importer":"信成股份有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":2
                            },
                            {
                                "id":"3",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"爾邦得有限公司",
                                "importer":"爾邦得有限公司",
                                "manufacturer":"TERRA NOVA TRADING INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":3
                            },
                            {
                                "id":"4",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"RPAC,LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":4
                            },
                            {
                                "id":"5",
                                "name":"美國加州杏仁果",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"信和股份有限公司",
                                "importer":"信和股份有限公司",
                                "manufacturer":"VANN FAMLLY ORCHARDS",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":5
                            },
                            {
                                "id":"6",
                                "name":"甜扁桃仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"TWIN COMMODITIES,INC.",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":6
                            },
                            {
                                "id":"7",
                                "name":"帶皮杏仁粒",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"昇祥股份有限公司",
                                "importer":"昇祥股份有限公司",
                                "manufacturer":"美國加州皮爾農場公司",
                                "originPlace":"美國加州",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":7
                            },
                            {
                                "id":"8",
                                "name":"有機生糙米粉(台灣)",
                                "storageCondition":"refrigeration",
                                "domesticVendor":"青田農產有限公司",
                                "importer":"",
                                "manufacturer":"青田農產有限公司",
                                "originPlace":"台灣",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":8
                            },
                            {
                                "id":"9",
                                "name":"精製椰子油",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"禾發實業有限公司",
                                "importer":"禾發實業有限公司",
                                "manufacturer":"OLEO-FATS, INCORPORATED",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":9
                            },
                            {
                                "id":"10",
                                "name":"杏仁細粉",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"迦得貿易實業有限公司",
                                "importer":"迦得貿易實業有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"菲律賓",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":10
                            },
                            {
                                "id":"11",
                                "name":"杏仁粉(細)",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"成久旺股份有限公司",
                                "importer":"成久旺股份有限公司",
                                "manufacturer":"Treehouse California Almonds LLC",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"",
                                "processingAid":"N",
                                "accessory":"N",
                                "ingredientOrder":11
                            },
                            {
                                "id":"12",
                                "name":"混合濃縮生育醇",
                                "storageCondition":"roomTemperature",
                                "domesticVendor":"信意企業股份有限公司",
                                "importer":"信意企業股份有限公司",
                                "manufacturer":"CARGILL INCORPORATED",
                                "originPlace":"美國",
                                "additiveLicenseNumber":"衛部添製字第002764號/TFAA1N002764004",
                                "processingAid":"N",
                                "accessory":"N"
                            }
                        ]
                    },
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"reduce",
                "reduceTypes": ["productionLine", "product/packagingMethod/spec"],
                "reducedProductionLines": [
                    1
                ],
                "reducedProducts": [
                    3, 4
                ],
                "description": "異動說明................"
            },
            {
                "changeType":"endAssessment",
                "assessmentPlaces": [
                    {
                        "id": "1",
                        "name": "台東廠",
                        "status": "approve",
                        "certificateEffectiveDate": "2022-10-10T00:00:00.000Z",
                    },
                    {
                        "id": "2",
                        "name": "屏東廠",
                        "status": "approve",
                        "certificateEffectiveDate": "2023-11-10T00:00:00.000Z",
                    },
                ],
                "endedAssessments": ["1"],
                "description": "異動說明................"
            },
            {
                "changeType":"postponeInspection",
                "assessmentPlaces": [
                    {
                        "id":"1",
                        "name":"台東廠",
                        "inspectionYear": 2022,
                        "inspectionSeason": "Q1",
                        "postponedInspectionYear": 2022,
                        "postponedInspectionSeason": "Q2",
                    },
                    {
                        "id":"2",
                        "name":"屏東廠",
                        "inspectionYear": 2022,
                        "inspectionSeason": "Q2",
                        "postponedInspectionYear": 2022,
                        "postponedInspectionSeason": "Q3",
                    }
                ],
                "postponedInspections": ["2"],
                "description": "異動說明................"
            },
            {
                "changeType":"resumeSuspend",
                "resumeTypes": ["resumeAssessmentPlace", "resumeAssessmentProduct"],
                "suspendAssessmentPlaces":[
                    {"name": "嘉義廠", "suspendDate": "2021-05-02T00:00:00.000Z"},
                    {"name": "雲林廠", "suspendDate": "2021-08-05T00:00:00.000Z"},
                ],
                "resumedAssessmentPlaces": [1],
                "suspendAssessmentProducts": [
                    {"name": "產品1", "suspendDate": "2021-05-02T00:00:00.000Z"},
                    {"name": "產品2", "suspendDate": "2021-08-05T00:00:00.000Z"},
                    {"name": "產品3", "suspendDate": "2021-12-25T00:00:00.000Z"},
                    {"name": "產品4", "suspendDate": "2022-01-11T00:00:00.000Z"},
                ],
                "resumedAssessmentProducts": [0, 1],
                "description": "異動說明................"
            },
        ],
    },
    {
        "id":"3",
        "collNo":"R21080103",
        "appNo":"A21080203",
        "type":"initial",
        "phase":"inspection",
        "activity":"inspection_S30",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "customerNo":"00001",
        "stayDays":2,
        "ncrs":[
            {"no":"INS01201", "inspectionItem":"03-1","observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ]},
            {"no":"INS01202", "inspectionItem":"05-1","observationDesc":"秤添加物電子秤CL-P011(1.8kg),內校300g",},
            {"no":"INS01203", "inspectionItem":"07-3","observationDesc":"肌肉骨骼關節疾病出現新的治療選擇，目前已能藉由體外震波能促進組織再生與緩解疼痛"}
        ]
    },
    {
        "id": "4",
        "collNo":"R21080104",
        "appNo":"A21080204",
        "type":"initial",
        "phase":"writtenReview",
        "activity":"writtenReview_S10",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "customerNo":"00001",
        "stayDays":4,
        "followUpRequests": [
            {
                "observation": "碳酸鈣550g/包,未涵蓋使用範圍",
                "comment": "Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流",
                "carNo": "INS01-01",
                "replyHistory": [
                    {
                        "notifiedDate": "2021-12-24T00:00:00.000Z",
                        "ncrDesc": "不符合之描述 .....................................",
                        "replyContent": "回覆內容 ......................................",
                        "replyDate": "2021-12-25T00:00:00.000Z",
                        "estimatedImprovementDate": "2021-12-31T00:00:00.000Z",
                    },
                    {
                        "notifiedDate": "2022-01-01T00:00:00.000Z",
                        "ncrDesc": "不符合之描述 ...........................",
                        "replyContent": "回覆內容 ...........................................",
                        "replyDate": "2022-01-14T00:00:00.000Z",
                        "estimatedImprovementDate": "2022-01-15T00:00:00.000Z",
                    },
                ],
            },
            {
                "observation": "秤添加物電子秤CL-P011(1.8kg),內校300g",
                "comment": "Gurman 並且稱該頭戴裝置「最快 2022」年可以到來，而且未來蘋果也會推出「單純 AR」的機種，但那要再多等幾年才會來臨了眾人在期待的，更多還是蘋果能不能利用其格外強大的產品開發與行銷能力，將 MR 帶進主流",
                "carNo": "INS01-02",
                "replyHistory": [
                    {
                        "notifiedDate": "2021-12-24T00:00:00.000Z",
                        "ncrDesc": "不符合之描述 ...............................",
                        "replyContent": "回覆內容 ...............................................",
                        "replyDate": "2021-12-25T00:00:00.000Z",
                        "estimatedImprovementDate": "2021-12-31T00:00:00.000Z",
                    },
                    {
                        "notifiedDate": "2022-01-01T00:00:00.000Z",
                        "ncrDesc": "不符合之描述 ...............................",
                        "replyContent": "回覆內容 .............................................",
                        "replyDate": "2022-01-14T00:00:00.000Z",
                        "estimatedImprovementDate": "2022-01-15T00:00:00.000Z",
                    },
                ],
            }
        ]
    },
    {
        "id":"5",
        "collNo":"R21080105",
        "appNo":"A21080205",
        "type":"initial",
        "phase":"onsiteReview",
        "activity":"onsiteReview_S30",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "customerNo":"00001",
        "stayDays":2,
        "ncrs":[
            {"no":"INS01201", "inspectionItem":"03-1","observationDesc":"碳酸鈣550g/包,未涵蓋使用範圍",
                "correctionHistories":[
                    {"replyDate":"2021-09-18T08:20:10.000","correctionActionPlan":"規劃加強清潔次數","estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-19T08:20:10.000","evaluationContent":"請提供具體計畫內容"},
                    {"replyDate":"2021-09-21T08:20:10.000","correctionActionPlan":"規劃每週清潔次數由1次改成2次", "estimatedImprovementDate":"2021-09-19T08:20:10.000" ,"verifyDate":"2021-09-22T08:20:10.000","evaluationContent":"請說明預計開始實施日期"}
                ]},
            {"no":"INS01202", "inspectionItem":"05-1","observationDesc":"秤添加物電子秤CL-P011(1.8kg),內校300g"},
            {"no":"INS01203", "inspectionItem":"07-3","observationDesc":"肌肉骨骼關節疾病出現新的治療選擇，目前已能藉由體外震波能促進組織再生與緩解疼痛"}
        ]
    },
    {
        "id":"6",
        "appNo":"A21100101",
        "type":"violation",
        "activity":"violation_S40",
        "createdOn":"2021-05-12T08:20:10.000Z",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "customerNo":"00001",
        "stayDays":2,
        "violationData": {
            "violationType":"quality",
            "appNo":"A21080501",
            "product":"杏仁玄米餅",
            "packingMethod":"paperBag",
            "spec":"800g/盒",
            "effectiveDate":"2022-08-13T00:00:10.000Z",
            "supplementDesc": "補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 補件說明 ",
            "unqualifiedTestItems": [
                {
                    "testType": "finishedGood",
                    "testName": "杏仁玄米餅",
                    "testItems":[
                        {"testItem":"11"}
                    ],
                    "violationReason":"外標示、廣告文宣或網路宣傳未經本公司審核",
                    "testEffectiveDate": "2023-02-07T00:00:00.000Z",
                },
                {
                    "testType": "rawMaterial",
                    "testName": "原料1",
                    "testItems":[
                        {"testItem":"01"},
                        {"testItem":"02", "details":["0201","0202"]}
                    ],
                    "violationReason":"重金屬:鎘0.5ppm(法規0.3 ppm)",
                    "testEffectiveDate": "2023-02-07T00:00:00.000Z",
                }
            ],
            "correctionReplyHistory": [
                {"supplementNotifyingDate": "2022-01-17T00:00:00.000Z", "supplementDesc": "補件說明補件說明補件說明補件說明", "replyDate": "2022-01-24T00:00:00.000Z", "replyContent": "回覆內容............"},
                {"supplementNotifyingDate": "2022-01-18T00:00:00.000Z", "supplementDesc": "補件說明補件說明補件說明補件說明", "replyDate": "2022-01-25T00:00:00.000Z", "replyContent": "回覆內容............"},
                {"supplementNotifyingDate": "2022-01-19T00:00:00.000Z", "supplementDesc": "補件說明補件說明補件說明補件說明", "replyDate": "2022-01-26T00:00:00.000Z", "replyContent": "回覆內容............"},
            ],
        },
    },
    {
        "id":"7",
        "appNo":"A21100102",
        "type":"markReview",
        "activity":"markReview_S30",
        "createdOn":"2021-11-01T08:20:10.000Z",
        "customerName":"源天然股份有限公司",
        "assessmentPlace":"台東廠",
        "customerNo":"00001",
        "stayDays":2,
        "markReviewProducts": [
            {
                "productName": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "tinplateCan",
                "spec": "360ml/罐",
                "changeDescription": "異動說明......",
                "reviewResult": "agree",
                "reviewComments": "審查說明......",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf",
                        "agree": true,
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf",
                        "agree": true,
                    },
                ],
                "reviewHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ]
            },
            {
                "productName": "Natural Benefits 食安生技-椰子汁",
                "packagingMethod": "glassBottle",
                "spec": "360ml/瓶",
                "changeDescription": "異動說明......",
                "reviewResult": "modify",
                "reviewComments": "審查說明......",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf",
                        "agree": true,
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf",
                        "agree": true,
                    },
                ],
                "reviewHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ]
            },
            {
                "productName": "Natural Benefits 純在-蔬菜綜合果汁",
                "packagingMethod": "aluminumFoil",
                "spec": "360ml/包",
                "changeDescription": "異動說明......",
                "reviewResult": "reject",
                "reviewComments": "審查說明......",
                "tseyueLevel": "clean",
                "channel": "leezen",
                "productType": "general",
                "markFileAgreements": [
                    {
                        "fileName": "0190222_FMC新鮮屋_特濃黑可可-滿版-01.pdf",
                    },
                    {
                        "fileName": "20190222_FMC新鮮屋_特濃黑可可-滿版-02.pdf",
                    },
                ],
                "reviewHistory": [
                    {
                        "reviewDate": "2021-10-01T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-10-08T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                    {
                        "reviewDate": "2021-11-04T00:00:00.000Z",
                        "reviewResult": "agree",
                        "reviewDesc": "審查說明............",
                        "replyDate": "2021-11-11T00:00:00.000Z",
                        "EditDesc": "修改說明............",
                    },
                ]
            },
        ],
    },
]

export default inboxes;